import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { getAddressData, getCollectionData, clearReduxStore, clearCollectionDay, selectedAddress, enteredPostcode } from '../redux/slice/collectionSlice';
import { fetchCalendarData } from '../redux/slice/calenderSlice';
import { clearDataInSessionStorage, encryptData, getItem, setDataInSessionStorage } from '../utils/utils';
import CustomButton from '../common/CustomButton';
import { useTranslation } from 'react-i18next';

const FindRubbishCollection = (props) => {
  const {
    addressDataList,
    getAddressData,
    getCollectionData,
    clearReduxStore,
    clearCollectionDay,
    selectedAddress,
    setSelectedPostcode,
    themeSettingsData,
    selectedAddressValue,
    enteredPostcode,
    postCode,
    collectionsList,
  } = props;
  const { t, i18n } = useTranslation();
  const [postcodeValue, setPostcodeValue] = useState(postCode ? postCode : '');
  const [addressOption, setAddressOption] = useState([]);
  const [disableFields, setDisableFields] = useState(collectionsList ? true : false);
  const [formValues, setFormValues] = useState(
    selectedAddressValue
      ? { addressSelect: selectedAddressValue?.value }
      : {
          addressSelect: '',
        }
  );
  const accessKeys = getItem('accessKeys');

  const handleInputChange = (e) => {
    const value = e.toUpperCase();
    setFormValues({ ...formValues, ['addressSelect']: '' });
    setAddressOption([]);
    setPostcodeValue(value);
    clearDataInSessionStorage('addressValue');
    clearCollectionDay([]);
  };

  const handleOnSelect = (fieldName, value, selectedOption) => {
    setSelectedPostcode({ value: value, label: selectedOption.id });
    selectedAddress({ value: value, label: selectedOption.id });
    setFormValues({ ...formValues, [fieldName]: value });
    enteredPostcode(postcodeValue);
    const apiPayload = {
      P_UPRN: value,
      P_CLIENT_ID: accessKeys?.P_CLIENT_ID,
      P_COUNCIL_ID: accessKeys?.P_COUNCIL_ID,
      P_LANG_CODE: i18n.language.toUpperCase(),
    };
    const encryptedData = encryptData(apiPayload);
    setDataInSessionStorage('selectedUPRN', value);
    getCollectionData(encryptedData);
    setDisableFields(true);
  };
  const handleOpenUrl = () => {
    const language = i18n.language;
    if (language === 'cy') {
      window.open(`https://www.royalmail.com/cy/find-a-postcode`, '_blank');
    } else {
      window.open(`https://www.royalmail.com/find-a-postcode`, '_blank');
    }
  };

  //clearing field and reset all value
  const clearAllField = () => {
    setFormValues({ ...formValues, ['addressSelect']: '' });
    setAddressOption([]);
    setPostcodeValue('');
    clearDataInSessionStorage('postCodeValue');
    clearDataInSessionStorage('addressValue');
    clearReduxStore(null);
    setDisableFields(false);
  };
  //check if input value grater than 6 than allow api call with 1 sec delay
  const findButtonClick = () => {
    if (postcodeValue.length >= 5) {
      const apiPayload = {
        P_POSTCODE: postcodeValue,
        P_LANG_CODE: i18n.language.toUpperCase(),
        P_CLIENT_ID: accessKeys?.P_CLIENT_ID,
        P_COUNCIL_ID: accessKeys?.P_COUNCIL_ID,
      };
      const encryptedApiData = encryptData(apiPayload);
      getAddressData(encryptedApiData);
      setAddressOption([]);
    }
  };

  //changing select option in select field
  useEffect(() => {
    if (addressDataList?.ADDRESS?.length > 0) {
      const addressList = addressDataList?.ADDRESS?.map((d) => {
        return { value: d.UPRN, label: d.FULL_ADDRESS };
      });
      setAddressOption(addressList);
    }
  }, [addressDataList]);

  return (
    <div className=" " style={{ width: '100%' }}>
      <div className="d-flex flex-column p-3 " style={{ backgroundColor: '#F3F2F1' }}>
        {addressDataList?.ADDRESS === null ? (
          <div className="govuk-error-summary" data-module="govuk-error-summary">
            <div role="alert">
              <h2 className="govuk-error-summary__title">Error</h2>
              <div className="govuk-error-summary__body">
                <ul className="govuk-list govuk-error-summary__list">
                  <li>{t('errorMSG')}</li>
                </ul>
              </div>
            </div>
          </div>
        ) : (
          ''
        )}
        <h2 className="govuk-label-wrapper">
          <label className="govuk-label govuk-label--l" htmlFor="postcodeSearch">
            {t('enterPostcode')}
          </label>
        </h2>
        <span style={{ color: '#383838' }}>{`${t('forExample')} SW1A 2AA`}</span>
        <input
          className="govuk-input"
          id="postcodeSearch"
          name="postcodeSearch"
          type="text"
          style={{ width: 160 }}
          maxLength={12}
          value={postcodeValue}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              findButtonClick();
            }
          }}
          disabled={disableFields}
          onChange={(e) => handleInputChange(e.target.value)}
        />
        {addressOption.length > 0 ? (
          ''
        ) : (
          <div>
            <button className="govuk-button mt-4" data-module="govuk-button" style={{ width: '110px' }} onClick={() => findButtonClick()}>
              {t('find')}
            </button>
          </div>
        )}

        {addressOption.length > 0 ? (
          <div className="mt-4 d-flex flex-column">
            <h2 className="govuk-label-wrapper">
              <label className="govuk-label govuk-label--l mt-2" htmlFor="addressSelect">
                {t('selectAddress')}
              </label>
            </h2>
            <select
              className="govuk-select"
              id="addressSelect"
              name="addressSelect"
              value={formValues.addressSelect}
              onChange={(e) => {
                const selectedOption = e.target.options[e.target.selectedIndex];
                handleOnSelect('addressSelect', e.target.value, selectedOption);
              }}
              disabled={disableFields}
              placeholder="Please select address"
              style={{ width: 300, height: '44px' }}
            >
              <option value="">{t('pleaseSelectAddress')}</option>;
              {addressOption?.map((d) => {
                return (
                  <option value={String(d.value)} id={d.label} key={String(d.value)}>
                    {d.label}
                  </option>
                );
              })}
            </select>
            {/* <div className="govuk-checkboxes" data-module="govuk-checkboxes">
                <div className="govuk-checkboxes__item">
                  <input className="govuk-checkboxes__input" id="waste" name="waste" type="checkbox" value="carcasses" />
                  <label className="govuk-checkboxes__label fw-bold" htmlFor="waste">
                    Make this address my default home address
                  </label>
                </div>
              </div> */}
            <div className="mt-2">
              <CustomButton themeSettingsData={themeSettingsData} onClick={clearAllField} disable={false}>
                {t('clearAddress')}
              </CustomButton>
            </div>
          </div>
        ) : (
          <div>
            <CustomButton themeSettingsData={themeSettingsData} onClick={handleOpenUrl} disable={false}>
              {t('findPostcodeOn')}
            </CustomButton>
          </div>
        )}
      </div>
    </div>
  );
};
const mapStateToProps = ({ collectionData, themeSlice }) => {
  const { themeSettingsData } = themeSlice;
  const { addressDataList, selectedAddressValue, postCode, collectionsList } = collectionData;
  return { addressDataList, themeSettingsData, selectedAddressValue, postCode, collectionsList };
};

const mapDispatchToProps = {
  getAddressData,
  getCollectionData,
  clearReduxStore,
  clearCollectionDay,
  selectedAddress,
  fetchCalendarData,
  enteredPostcode,
};
export default connect(mapStateToProps, mapDispatchToProps)(FindRubbishCollection);
